// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__m87J0","spin":"Spinner_spin__nT+vK","path":"Spinner_path__lVQ1C","dash":"Spinner_dash__q2EBB","centerWrap":"Spinner_centerWrap__dR7ns"};